module.exports = __webpack_public_path__ + "img/1.05cf6db2.jpg";